import wx from 'weixin-js-sdk';
import { NavigateType } from './types';

export const wxBridge = {
  getEnv: () => {
    return wx.miniProgram.getEnv(res => {
      console.log('wx.getEnv', res);
    });
  },
  postMessage: (data: any) => {
    wx.miniProgram.postMessage({ data });
  },
  routerTo: ({ type, url = '' }: { type: NavigateType; url?: string }) => {
    switch (type) {
      case 'push':
        wx.miniProgram.navigateTo({ url });
        break;

      case 'replace':
        wx.miniProgram.redirectTo({ url });
        break;

      case 'back':
        wx.miniProgram.navigateBack({ delta: '1' } as any);
        break;

      default:
        break;
    }
  },
};
